<div class="body-wrap">
  <router-outlet></router-outlet>
</div>
